import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px 26px;
  height:100%;
`;
